import { Box, Typography, Chip } from '@mui/material';
import { PARCEL_TYPES, COLORS } from '../utils/constants';

/**
 * Modern parcel type selector with icon grid
 * Supports compact mode for inline display
 */
export default function ParcelTypeSelector({ selectedTypes, onToggle, compact = false }) {
  if (compact) {
    // Compact horizontal chip layout
    return (
      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.75 }}>
        {PARCEL_TYPES.map((type) => {
          const isSelected = selectedTypes.includes(type.label);
          const IconComponent = type.icon;

          return (
            <Chip
              key={type.label}
              icon={<IconComponent sx={{ fontSize: 16 }} />}
              label={type.label}
              onClick={() => onToggle(type.label)}
              variant={isSelected ? 'filled' : 'outlined'}
              size="small"
              sx={{
                borderColor: isSelected ? COLORS.primary : COLORS.border,
                bgcolor: isSelected ? COLORS.primary : 'transparent',
                color: isSelected ? COLORS.white : COLORS.textPrimary,
                fontWeight: 600,
                fontSize: '0.75rem',
                height: 32,
                '& .MuiChip-icon': {
                  color: isSelected ? COLORS.white : COLORS.textSecondary,
                },
                '&:hover': {
                  borderColor: COLORS.primary,
                  bgcolor: isSelected ? COLORS.primary : 'rgba(0,0,0,0.04)',
                },
              }}
            />
          );
        })}
      </Box>
    );
  }

  // Original grid layout
  return (
    <Box>
      <Typography
        variant="body2"
        sx={{
          fontWeight: 600,
          color: COLORS.textPrimary,
          mb: 1.5,
          fontSize: '0.875rem',
          letterSpacing: '0.5px',
        }}
      >
        What are you sending?
      </Typography>
      <Box
        sx={{
          display: 'inline-grid',
          gridTemplateColumns: 'repeat(3, 1fr)',
          gap: 1,
        }}
      >
        {PARCEL_TYPES.map((type) => {
          const isSelected = selectedTypes.includes(type.label);
          const IconComponent = type.icon;

          return (
            <Box
              key={type.label}
              component="button"
              onClick={() => onToggle(type.label)}
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                gap: 0.5,
                p: 1,
                borderRadius: 2,
                border: `1.5px solid ${isSelected ? COLORS.primary : COLORS.border}`,
                background: isSelected ? COLORS.primary : COLORS.white,
                cursor: 'pointer',
                transition: 'all 0.15s ease',
                minHeight: 56,
                '&:hover': {
                  borderColor: COLORS.primary,
                  transform: 'scale(1.02)',
                },
                '&:active': {
                  transform: 'scale(0.98)',
                },
              }}
            >
              <IconComponent
                sx={{
                  fontSize: 18,
                  color: isSelected ? COLORS.white : COLORS.textPrimary,
                  transition: 'color 0.15s ease',
                }}
              />
              <Typography
                sx={{
                  fontSize: '0.66rem',
                  fontWeight: 600,
                  color: isSelected ? COLORS.white : COLORS.textSecondary,
                  textAlign: 'center',
                  lineHeight: 1.2,
                  transition: 'color 0.15s ease',
                }}
              >
                {type.label}
              </Typography>
            </Box>
          );
        })}
      </Box>
    </Box>
  );
}
